import '../css/style.css';
import Map from 'ol/Map';
import View from 'ol/View';
import ScaleLine from 'ol/control/ScaleLine';
import { layers, source } from './source.js';
import { select, searchNominatim, search } from './search.js';
import { lswitcher } from './layerSwitcher.js'
import { legendCtrl } from './legend.js'
import { infoLayer } from './layout';
import { selectallfeatures, selectfeature, selectBoundaries, popup } from './popupFeature';
import Permalink from 'ol-ext/control/Permalink'
import Draw from 'ol/interaction/Draw.js';
import Overlay from 'ol/Overlay.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { getLength } from 'ol/sphere.js';
import { unByKey } from 'ol/Observable.js';
import Notification from 'ol-ext/control/Notification';
import { transform } from 'ol/proj';
import ContextMenu from 'ol-contextmenu';
import { myModal } from './layout';
import Toggle from 'ol-ext/control/Toggle';
import Geolocation from 'ol/Geolocation.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Select from 'ol/interaction/Select.js';
import Bar from 'ol-ext/control/Bar';
import Rotate from 'ol/control/Rotate'



// ----------------------------------------default zoom, center and rotation, map ------------------------------------------------------------------------------
let zoom = 12.44;
let center = [2339441.64, 6844165.98];
let rotation = 0;
var view = new View({
  center: center,
  zoom: zoom,
  rotation: rotation,
  maxZoom: 18,
  minZoom: 7,
});


//------------measure---------
let sketch;
let helpTooltipElement;
let helpTooltip;
let measureTooltipElement;
let measureTooltip;
const continueLineMsg = 'Kliknij by kontynuować mierzenie, kliknij dwukrotnie by zakończyć';

const pointerMoveHandler = function (evt) {
  if (evt.dragging) {
    return;
  }

  let helpMsg = 'Kliknij by rozpocząć mierzenie';

  if (sketch) {
    helpMsg = continueLineMsg;
  }

  helpTooltipElement.innerHTML = helpMsg;
  helpTooltip.setPosition(evt.coordinate);

  helpTooltipElement.classList.remove('hidden');
};


const map = new Map({
  target: 'map',
  layers: layers,
  view: view,

});


//Permalink

// Control
var ctrl = new Permalink({

});
map.addControl(ctrl);

/////////--------------------------------------------Toolbox bar----------------------------------------------------------

// Main control bar
var mainbar = new Bar();
map.addControl(mainbar);
mainbar.setPosition('right');

mainbar.addControl(new Rotate());


///------------------------------------------------------Geolocation/Tracking--------------------------------------------------------

const geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: view.getProjection(),
});

// handle geolocation error.
geolocation.on('error', function (error) {
  const info = document.getElementById('info');
  info.innerHTML = error.message;
  info.style.display = '';
});

const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  }),
);

geolocation.on('change:position', function () {
  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
});

export const trackerLayer = new VectorLayer({
  source: new VectorSource({
    features: [accuracyFeature, positionFeature],
  }),
  displayInLayerSwitcher: false,
  layerName: 'trackerLayer'
});


// Add selection tool (a toggle control with a select interaction)
var geolocTracker = new Toggle({
  html: '<i class="fa-solid fa-location-crosshairs"></i>',
  className: "geolocTracker",
  title: "Geolocation tracker",
  interaction: new Select(),
  active: false,
  onToggle: function (active) {
    if (!active) {
      geolocation.setTracking(false);
      map.removeLayer(trackerLayer);
    } else {
      geolocation.setTracking(true);
      map.addLayer(trackerLayer);

      const onPosition = function () {
        const coordinates = geolocation.getPosition();
        if (coordinates) {
          map.getView().setCenter(coordinates);
          map.getView().setZoom(18);
        }
        geolocation.un('change:position', onPosition); // wyczyść listener po 1 użyciu
      };
      geolocation.on('change:position', onPosition);
    }
  }
});
mainbar.addControl(geolocTracker);







// ----------------------------------------------------------Search Photon--------------------------------------------------------------------------------


map.addInteraction(select);

//Search Nominatim

map.addControl(searchNominatim);

// Select feature when click on the reference index
searchNominatim.on('select', function (e) {
  map.getView().animate({
    center: e.coordinate,
    zoom: Math.max(map.getView().getZoom(), 14)
  });
  searchNominatim.clearHistory();
});

// Clear Search
$(document).ready(function () {
  $('.has-clear .form-control-clear').on('click', function () {
    var $input = $('.ol-search').find('input');

    $('.autocomplete').empty();

    $input.val('').trigger('change');
    // Trigger a "cleared" event on the input for extensibility purpose
    $input.trigger('cleared');
  });
});

//Search in miejscowosci layer
map.addControl(search);

// Select feature when click on the reference index
search.on('select', function (e) {
  select.getFeatures().clear();
  select.getFeatures().push(e.search);
  var p = e.search.getGeometry().getFirstCoordinate();
  map.getView().animate({
    center: p,
    zoom: Math.max(map.getView().getZoom(), 14)
  });
});


// Layer switcher
map.addControl(lswitcher);

// Scale control
map.addControl(new ScaleLine());


//----------------------------PopupFeature-----------------------------

map.addInteraction(selectfeature);
map.addInteraction(selectallfeatures);
map.addOverlay(popup);

//------------------------Popup boundaries-----------------------------

map.addInteraction(selectBoundaries);

map.on('singleclick', function (evt) {
  setTimeout(function () {

    var text = '';



    selectBoundaries.getFeatures().forEach(function (feature) {
      if (feature.getProperties().woj_p)
        text += 'województwo: ' + feature.getProperties().woj_p + '\n'
      else if (feature.getProperties().ziemia_p)
        text += 'ziemia: ' + feature.getProperties().ziemia_p + '\n'
      else if (feature.getProperties().powiat_p)
        text += 'powiat: ' + feature.getProperties().powiat_p + '\n'
      else if (feature.getProperties().g_diecezja)
        text += 'diecezja: ' + feature.getProperties().g_diecezja + '\n'
      else if (feature.getProperties().g_archidia)
        text += 'archidiakonat: ' + feature.getProperties().g_archidia + '\n'
      else if (feature.getProperties().g_dekanat)
        text += 'dekanat: ' + feature.getProperties().g_dekanat + '\n'
      else if (feature.getProperties().g_parafia)
        text += 'parafia: ' + feature.getProperties().g_parafia + '\n'

    })

    var div = $('<div>').text(text);
    /*  $('<a>').text('ok')
        .click(function() {
          notification.hide();
        })
        .appendTo(div);*/
    notification.show(div.get(0), 5000);
  }, 5)
})


var boundaries_notification = new Notification({
  className: 'boundariesInfo',
});
map.addControl(boundaries_notification);

// Legend

map.addControl(legendCtrl);

// -------------------------------------------Swap layer info

$("body").on("click", ".onLayerSwap", function () {
  let layername = $(this).attr('data-layername');
  map.getAllLayers().forEach(function (layer) {
    if (layer.get('layerName') == layername) {
      infoLayer(layer);
    }
  });
});


//-------------------------------------------parent-child layer switcher----------

function listenVisible(layer, group) {
  layer.on('change:visible', function (e) {
    if (layer.getLayers) {
      var vis = layer.getVisible();
      var index = 0;

      layer.getLayers().forEach(function (l) {
        if (l.getVisible() == true) {
          index = index + 1;
        }

      });
      if (index == 0 | vis == false) {
        layer.getLayers().forEach(function (l) {
          if (l.getVisible() !== vis) {
            // Prevent infinite loop
            l.setVisible(vis);
          }
        });
      }
    }
    // if inside a group, check visibility of layers in it
    if (group) {
      var vis = false;
      group.getLayers().forEach(function (l) {
        if (l.getVisible()) vis = true;
      });
      if (group.getVisible() !== vis) group.setVisible(vis);

    }
  });

  // Listen to layers in it
  if (layer.getLayers) {
    layer.getLayers().forEach(function (l) {
      listenVisible(l, layer);
    });
  }
}

map.getLayers().getArray().forEach(function (l) {
  listenVisible(l);
});

////---------------------------------------------------measure--------------------------------------------------------



let draw; // global so we can remove it later


const formatLength = function (line) {
  const length = getLength(line);
  let output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
};

function addInteraction() {
  draw = new Draw({
    source: source,
    type: 'LineString',
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
  });
  map.addInteraction(draw);

  createMeasureTooltip();
  createHelpTooltip();

  let listener;
  draw.on('drawstart', function (evt) {
    // set sketch
    sketch = evt.feature;

    let tooltipCoord = evt.coordinate;

    listener = sketch.getGeometry().on('change', function (evt) {
      const geom = evt.target;
      let output;
      output = formatLength(geom);
      tooltipCoord = geom.getLastCoordinate();
      measureTooltipElement.innerHTML = output;
      measureTooltip.setPosition(tooltipCoord);
    });
  });

  draw.on('drawend', function () {
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
    measureTooltip.setOffset([0, -7]);
    // unset sketch
    sketch = null;
    // unset tooltip so that a new one can be created
    measureTooltipElement = null;
    createMeasureTooltip();
    unByKey(listener);
  });
}

/**
 * Creates a new help tooltip
 */
function createHelpTooltip() {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'ol-tooltip hidden';
  helpTooltip = new Overlay({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left',
  });
  map.addOverlay(helpTooltip);
}

/**
 * Creates a new measure tooltip
 */
function createMeasureTooltip() {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
  measureTooltip = new Overlay({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center',
    stopEvent: false,
    insertFirst: false,
  });
  map.addOverlay(measureTooltip);
}

function removeElementsByClass(className) {
  const elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
}

/**
 * Start measure on click
 */


var measureBtn = new Toggle({
  html: '<i class="fa-solid fa-ruler fa-x1"></i>',
  className: "measureBtn",
  title: "Measure",
  interaction: new Select(),
  active: false,
  onToggle: function (active) {
    if (!active) {
      map.addOverlay(popup);
      map.removeOverlay(measureTooltip);
      map.removeOverlay(helpTooltip);
      map.removeInteraction(draw);
      source.clear();
      removeElementsByClass('ol-tooltip ol-tooltip-static');
    } else {
      map.removeOverlay(popup);
      map.on('pointermove', pointerMoveHandler);

      map.getViewport().addEventListener('mouseout', function () {
        helpTooltipElement.classList.add('hidden');
      });
      addInteraction();
    }
  }
});
mainbar.addControl(measureBtn);

/////-------get coordinates----------------------------------------------------

const contextmenu = new ContextMenu({
  width: 170,
  defaultItems: false, // defaultItems are (for now) Zoom In/Zoom Out
  items: [
    {
      text: 'Kopiuj współrzędne',
      classname: 'some-style-class', // add some CSS rules
      callback: copy, // `center` is your callback function
    },
  ],
});
map.addControl(contextmenu);

let coords = '';

map.getViewport().addEventListener('contextmenu', function (evt) {
  evt.preventDefault();
  coords = transform(map.getEventCoordinate(evt), 'EPSG:3857', 'EPSG:4326');
})



// Control
var notification = new Notification({
});
map.addControl(notification);

function copy() {

  navigator.clipboard.writeText(coords[1].toFixed(6) + ', ' + coords[0].toFixed(6));

  var div = $('<div>').text('Współrzędne skopiowane ');
  $('<a>').text('ok')
    .click(function () {
      notification.hide();
    })
    .appendTo(div);
  notification.show(div.get(0));

}



//-----------------------------------------------------table view-------------------------------

var tableBtn = new Toggle({
  html: '<i class="fa-solid fa-table-list fa-x1"></i>',
  className: "tableBtn",
  title: "Table view",
  interaction: selectallfeatures,
  active: false,
  onToggle: function (active) {
    if (!active) {
      map.addOverlay(popup);
    } else {
      map.removeOverlay(popup);
    }
  }
});
mainbar.addControl(tableBtn);


//----------------------------Features table-----------------------------

map.on('singleclick', function (evt) {
  setTimeout(function () {

    var text1 = '<table style="width: 100%; border-collapse: collapse; border: 1px solid rgb(0, 0, 0);text-align: center; padding: 2px;"> ' +
      '<thead>' +
      '<tr>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Nazwa szesnastowieczna</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Parafia</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Nazwa współczesna</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Charakter osady</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rodzaj własności</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Powiat</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Województwo</th>' +
      '</tr>' +
      '</thead>';
    var text2 = '<table style="width: 5000px; border-collapse: collapse; border: 1px solid rgb(0, 0, 0);text-align: center; padding: 2px;">' +
      '<thead>' +
      '<tr>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Identyfikator osady</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Nazwa XVi-wieczna</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rok</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Data</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Data – forma źródłowa</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Sygnatura</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Strona</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Link do skanu</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Numer zapiski</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Parafia</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Charakter osady</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Nazwa źródłowa</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Właściciel forma źródłowa</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Osoby</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rodziny</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Obiekty</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Wyszynk – grosze</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Wyszynk – opis</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Karczma</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Karczma dziedziczna</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Karczma doroczna</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Koło walne</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Koło korzeczne</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Koło dziedziczne</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Koło doroczne</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Wiatrak</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Wiatrak dziedziczny</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Wiatrak doroczny</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Liczba innych kół</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rodzaj innych kół</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Garnce gorzałczane</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Łany kmiece</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Łany puste</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Łany szlachty zagrodowej</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Łany sołtysie</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Liczba innych łanów</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rodzaj innych łanów</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Suma łanów</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Owce</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rybacy</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Liczba rzemieślników</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Lista zawodów</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Czeladnicy</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Zagrodnicy niesprecyzowani</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Zagrodnicy z ziemią</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Zagrodnicy bez ziemi</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Zagrodnicy z domem</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Komornicy niesprecyzowani i miejscy</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Komornicy z dobytkiem</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Komornicy bez dobytku</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rataje</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Ludzie luźni</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Żydzi – grosze</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Szos – floreny</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Szos – grosze</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Szos w groszach</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Suma – floreny</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Suma – grosze</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Suma – denary</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Suma w groszach</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Liczba kmieci</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Varia</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Pop ruski</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Podatek od popa</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Konie</th>' +
      '<th style="border: 1.5px solid rgb(0, 0, 0);">Rejestr</th>' +
      '</tr>' +
      '</thead>';

    var count1 = 0;
    var count2 = 0;
    selectallfeatures.getFeatures().forEach(function (feature) {

      $('.modal-title').html(feature.getProperties().nazwa_16w + '<br/>');
      if (feature.getProperties().id_miejscowosci) {
        count1 += 1;
        text1 = text1 +
          '<tbody>' +
          '<tr>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().nazwa_16w + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().parafia + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().nazwa_wspolczesna + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().charakter_osady + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rodzaj_wlasnosci + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().powiat_p + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().woj_p + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>';

      } else if (!feature.getProperties().id_miejscowosci) {
        count2 += 1;
        text2 = text2 +
          '<tr>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().id_osady + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().nazwa_16w + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rok + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().data + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().data_zrd + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().sygn + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().str + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().link_do_skanu + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().nr_not + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().parafia + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().char_osady + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().nazw_zrd + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().wlasciciel + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().osoby + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rodziny + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().obiekty + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().wyszynk_gr + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().wyszynk_opis + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().taberna + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().tbr_hrd + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().tbr_man + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().k_walne + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().k_korz + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rota_hrd + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rota_ann + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().wiatrak + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().wtr_hrd + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().wtr_ann + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().k_inne_lb + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().k_inne_kom + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().garnce_gorz + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().lany_kmc + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().lany_pust + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().aratura_sua + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().lany_solt + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().inne_lany_lb + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().inne_lany_kom + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().lany_suma + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().owce + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rybacy + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rzem_lb + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rzem_lista + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().czeladnicy + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().zagr_niesprec + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().zagr_ziem + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().zagr_bez + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().zagr_dom + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().kom_niesprec + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().kom_dob + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().kom_bez + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rataje + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().luzni + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().zydzi_gr + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().szos_fl + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().szos_gr + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().szos_w_gr + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().suma_fl + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().suma_gr + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().suma_den + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().suma_w_gr + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().kmc_liczba + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().varia + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().pop_ruski + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().pop_podatek + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().konie + '</td>' +
          '<td style="border: 1px solid rgb(0, 0, 0);">' + feature.getProperties().rejestr + '</td>' +
          '</tr>'
          ;
      }

    });

    if (count1 > 0 && count2 > 0) {
      var text = text1 + '<p><br></p>' +
        '<p><br></p>' + text2;
    } else if (count1 > 0 && count2 == 0) {
      var text = text1;
    } else if (count1 == 0 && count2 > 0) {
      var text = text2;
    } else {
      var text = '';
    }
    text = text.replace(/null/g, '');
    text = text.replace(/undefined/g, '');
    text = text.replace(/.JPG/g, '.JPG" target="_blank" rel="noopener noreferrer">zob. źródło</a>');
    text = text.replace(/.jpg/g, '.jpg" target="_blank" rel="noopener noreferrer">zob. źródło</a>');
    text = text.replace(/http/g, '<a href="http');
    $('.modal-body').html('');
    $('.modal-body').append(text);

    if ($('.tableBtn').hasClass('ol-active') && text != '') {
      myModal.show();
    }

  }, 5);
})
